<template>
  <div class="bg-white text-left py-6 px-12">
    <div class="pt-6 space-y-6">
      <div>
        <p class="text-lg font-semibold mb-4">{{ $t("余额充值") }}</p>
        <div class="grid grid-cols-3 gap-4 max-w-3xl">
          <button
            v-for="item in amountOptions"
            :key="item.value"
            type="button"
            class="amount-item"
            :class="{ active: selectedAmount === item.value }"
            @click="selectAmount(item.value)"
          >
            <span v-if="item.value === 'custom'">{{ $t("自定义") }}</span>
            <span v-else>{{ formatCny(item.value) }}</span>
          </button>
        </div>
      </div>

      <div v-if="selectedAmount === 'custom'" class="max-w-md">
        <el-input
          v-model="customMoney"
          type="number"
          :placeholder="$t('请输入充值金额')"
          @input="setCustomMoney"
        ></el-input>
      </div>

      <div class="space-y-2">
        <p>
          {{ $t("充值金额") }}:
          <span class="text-hex-F89600 text-xl">
            {{ formatCny(payMoney) }}
            <span class="text-sm text-hex-909090">
              ({{ $t("需支付约") }}{{ approximatePayMoney }})
            </span>
          </span>
        </p>
        <p class="text-0.75rem text-hex-909090 pb-5">
          {{ $t("请选择或输入充值金额后确认支付") }}
        </p>
        <el-button type="warning" class="text-1rem" @click="confirm">
          {{ $t("确认支付") }}
        </el-button>
      </div>
    </div>
    <ReadyPay ref="readypay"></ReadyPay>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "@vue/composition-api";
import ReadyPay from "/src/components/base/ir-readypay.vue";

export default {
  components: { ReadyPay },
  setup(props, ctx) {
    const amountOptions = [
      { value: 50 },
      { value: 100 },
      { value: 200 },
      { value: 500 },
      { value: 1000 },
      { value: "custom" },
    ];
    const selectedAmount = ref(50);
    const payMoney = ref(50);
    const customMoney = ref("");
    const readypay = ref(null);
    const minPayMoney = 50;
    const maxPayMoney = 10000;
    const approximatePayMoney = computed(() => ctx.root.$p(payMoney.value));

    const formatCny = (value) => {
      const money = Number(value) || 0;
      return `￥${money.toFixed(2).replace(/\.00$/, "")}`;
    };

    const setPayMoney = (value) => {
      payMoney.value = Number(value) || 0;
    };

    const selectAmount = (value) => {
      selectedAmount.value = value;
      if (value !== "custom") {
        customMoney.value = "";
        setPayMoney(value);
      } else {
        setPayMoney(customMoney.value);
      }
    };

    const setCustomMoney = (value) => {
      customMoney.value = value;
      setPayMoney(value);
    };

    const throwPayMoneyError = async (message) => {
      await ctx.root.$msg(message);
      throw new Error(message);
    };

    const validatePayMoney = async () => {
      const money = Number(payMoney.value);
      if (!money || money <= 0) {
        await throwPayMoneyError(ctx.root.$t("请输入正确的充值金额"));
      }
      if (minPayMoney && money < minPayMoney) {
        await throwPayMoneyError(
          ctx.root.$t("充值金额不能低于{0}", formatCny(minPayMoney))
        );
      }
      if (maxPayMoney && money > maxPayMoney) {
        await throwPayMoneyError(
          ctx.root.$t("充值金额不能高于{0}", formatCny(maxPayMoney))
        );
      }
    };

    onMounted(() => {
      if (ctx.root.$route.query.payMoney) {
        const queryMoney = Number(ctx.root.$route.query.payMoney);
        payMoney.value = queryMoney;
        if (amountOptions.some((item) => item.value === queryMoney)) {
          selectedAmount.value = queryMoney;
        } else {
          selectedAmount.value = "custom";
          customMoney.value = String(queryMoney);
        }
      }
    });

    const confirm = async () => {
      await validatePayMoney();

      ctx.root.$refs.readypay = readypay.value;
      const payResult = await ctx.root.$startPay({
        balance: false,
        data: {
          now_platform: "webpc",
          origin_url: "/mine/wallet",
        },
        money: payMoney.value,
        payfor: "recharge",
        title: ctx.root.$t("余额充值"),
      });

      if (payResult) {
        await ctx.root.$router.push({
          name: "Wallet",
        });
      }
    };

    return {
      amountOptions,
      selectedAmount,
      payMoney,
      customMoney,
      readypay,
      approximatePayMoney,
      formatCny,
      selectAmount,
      setCustomMoney,
      confirm,
    };
  },
};
</script>

<style scoped lang="scss">
.amount-item {
  @apply h-12 border border-hex-E4E4E4 bg-white text-center cursor-pointer;
  border-radius: 4px;

  &.active {
    @apply border-main text-main;
    background: rgba(236, 103, 7, 0.08);
  }
}
</style>
